import type { ProductColor } from 'product/types'
import type { Stock } from 'product/types/Stock'

import type { Color, Size } from '../../types/FullProduct'
import { getIsSizeDelayed } from '../getDelayedTime/getIsSizeDelayed'

interface GetSizes {
	productColor: Omit<ProductColor, 'looks'> | Color
	stock: Stock
	relatedSizesStock: Stock[]
	defaultWarehouseId: string
}

export function getSizes({
	productColor,
	stock,
	relatedSizesStock,
	defaultWarehouseId,
}: GetSizes): Size[] {
	const sizes: Size[] = productColor.sizes.map((size) => {
		if (size.relatedProductId || productColor.relatedProductId) {
			// We protect this in case of the related size has other colors different to the original product
			const relatedSizeStock = relatedSizesStock.find(
				(relatedSizeStockColors) =>
					Boolean(
						relatedSizeStockColors.colors[productColor.id]?.sizes[size.id]
					)
			)

			// If we cant match the stock, we are defining the size as available so the shopping bag will check it again
			if (!relatedSizeStock) {
				return {
					...size,
					available: true,
					lastUnits: undefined,
					warehouses: undefined,
					isDelayed: false,
				}
			}

			const relatedSize =
				relatedSizeStock.colors[productColor.id].sizes[size.id]

			const relatedIsDelayed = getIsSizeDelayed({
				stockAvailability: relatedSize,
				defaultWarehouseId,
			})

			return {
				...size,
				available: relatedSize.available,
				lastUnits: relatedSize.lastUnits,
				warehouses: relatedSize.warehouses,
				isDelayed: relatedIsDelayed,
			}
		}

		const sizeStock = stock.colors[productColor.id].sizes[size.id]

		const isDelayed = getIsSizeDelayed({
			stockAvailability: sizeStock,
			defaultWarehouseId,
		})

		return {
			...size,
			...sizeStock,
			isDelayed,
			lastUnits: sizeStock.lastUnits,
			warehouses: sizeStock.warehouses,
		}
	})

	return sizes
}
